import { useEffect, useState } from 'react'
import Modal from 'react-modal'
import { adminService } from '../../services/admin.service'
import { UserDetailDto } from '@ivy-monorepo/shared'

interface UnlockModalProps {
  isOpen: boolean
  onClose: () => void
  publicId: string
  updateUser: (userData: UserDetailDto) => void
}

const UnlockUserModal = ({ isOpen, onClose, publicId, updateUser }: UnlockModalProps) => {
  const [unlockReason, setUnlockReason] = useState('')
  const [isUnlockPending, setIsUnlockPending] = useState(false)
  const [unlockError, setUnlockError] = useState<string | null>(null)

  const handleCloseUnlockModal = () => {
    if (isUnlockPending) return
    onClose()
  }

  const handleUnlock = async () => {
    if (!publicId) return
    const reason = unlockReason.trim()
    if (!reason) {
      setUnlockError('Reason is required.')
      return
    }

    try {
      setIsUnlockPending(true)
      setUnlockError(null)
      const updated = await adminService.unlockUser(publicId, reason)
      updateUser(updated)
      onClose()
    } catch (err) {
      console.log('Failed to unlock user', err)
      setUnlockError('Failed to unlock user.')
    } finally {
      setIsUnlockPending(false)
    }
  }

  useEffect(
    () => {
      if (!isOpen) {
        return
      }
      setUnlockReason('')
      setUnlockError(null)
    },
    [isOpen]
  )

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={handleCloseUnlockModal}
      className="modal-popup confirm-popup"
      overlayClassName="modal-overlay"
      closeTimeoutMS={300}
    >
      <div className="modal-content-wrapper">
        <h2>Unlock user</h2>
        <form className="modal-body-content">
          <div className="form-group">
            <label>Reason</label>
            <textarea
              value={unlockReason}
              onChange={(e) => setUnlockReason(e.target.value)}
              rows={3}
              disabled={isUnlockPending}
            />
          </div>
        </form>
        {unlockError && (
          <div className="page-error" style={{ margin: 0 }}>
            {unlockError}
          </div>
        )}
        <div className="modal-footer-content">
          <button type="button" className="styled-button" onClick={handleCloseUnlockModal} disabled={isUnlockPending}>
            Cancel
          </button>
          <button type="button" className="styled-button" onClick={handleUnlock} disabled={isUnlockPending || unlockReason.trim().length < 1}>
            Unlock
          </button>
        </div>
      </div>
    </Modal>
  )
}

export default UnlockUserModal
